import { formatPics, filterParams } from '@/common/utils/format'

import { get } from 'lodash-es'
import { i18n, getBDCountry, sprintf } from '@/common/utils/i18n'
const country = getBDCountry() || 'MX'


export function revert (data = {}) {
  const health = get(data, 'bizGlobal.docInfo.health')
  if (!health) return {}
  return {
    licensePics: formatPics(health.licensePics),
    files: formatPics(health.files)
  }
}

export function submitFormat (healthInfo) {
  return {
    params: JSON.stringify({
      source: 'contractor',
      queryId: this.$route.params.id,
      bizGlobal: {
        ...healthInfo.bizGlobal,
        country: country
      }
    })
  }
}

export default {
  revert,
  submitFormat
}
